// FETCH ALL PROPERTIES FROM DEFAULT_STYLE MASTER
export const FETCH_SECTION_REQUEST = 'FETCH_SECTION_REQUEST';
export const FETCH_SECTION_SUCCESS = 'FETCH_SECTION_SUCCESS';
export const FETCH_SECTION_FAILURE = 'FETCH_SECTION_FAILURE';

// CREATE PROPERTIES FOR DEFAULT_STYLE MASTER
export const CREATE_SECTION_REQUEST = 'CREATE_SECTION_REQUEST';
export const CREATE_SECTION_SUCCESS = 'CREATE_SECTION_SUCCESS';
export const CREATE_SECTION_FAILURE = 'CREATE_SECTION_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_SECTION = 'CREATE_USER_FORM_SECTION';

// FETCH SINGLE DEFAULT_STYLE
export const FETCH_SINGLE_SECTION_REQUEST = 'FETCH_SINGLE_SECTION_REQUEST';
export const FETCH_SINGLE_SECTION_SUCCESS = 'FETCH_SINGLE_SECTION_SUCCESS';
export const FETCH_SINGLE_SECTION_FAILURE = 'FETCH_SINGLE_SECTION_FAILURE';

// UPDATE PROPERTIES FOR DEFAULT_STYLE
export const UPDATE_SECTION_REQUEST = 'UPDATE_SECTION_REQUEST';
export const UPDATE_SECTION_SUCCESS = 'UPDATE_SECTION_SUCCESS';
export const UPDATE_SECTION_FAILURE = 'UPDATE_SECTION_FAILURE';

// DELETE PROPERTIES FOR DEFAULT_STYLE MASTER
export const DELETE_SECTION_REQUEST = 'DELETE_SECTION_REQUEST';
export const DELETE_SECTION_SUCCESS = 'DELETE_SECTION_SUCCESS';
export const DELETE_SECTION_FAILURE = 'DELETE_SECTION_FAILURE';

//RESET SECTION_USER_FORM
export const RESET_SECTION_USER_FORM = 'RESET_SECTION_USER_FORM';
